import { Component, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TicketService } from "src/app/services/ticket.service";
import { AuthService, HelpersService } from "@evento-ng/libs";

@Component({
  selector: "app-sales-info",
  templateUrl: "./sales-info.component.html",
  styleUrls: ["./sales-info.component.scss"],
})
export class SalesInfoComponent {
  @Output() backToTickets = new EventEmitter();
  infoForm!: FormGroup;
  user: any;
  constructor(
    private fb: FormBuilder,
    private ticketService: TicketService,
    private helpers: HelpersService,
    private router: Router,
    private authService: AuthService
  ) {
    this.user = this.authService.user.getValue();
  }

  ngOnInit(): void {
    this.initInfo();
    this.infoForm.valueChanges.subscribe((_) => {
      if (this.infoForm.valid) {
        this.ticketService.updateBookTicket({
          info: {
            ...this.infoForm.value,
            firstName: this.infoForm.get("firstName")?.value.trim(),
            lastName: this.infoForm.get("lastName")?.value.trim(),
            isValid: this.infoForm.valid,
          },
        });
      } else {
        const currentInfo = this.ticketService.bookTicket.getValue()?.info;
        this.ticketService.updateBookTicket({
          info: { ...currentInfo, isValid: this.infoForm.valid },
        });
      }
    });
  }

  private initInfo(): void {
    let firstName;
    let lastName;
    let email;
    let mobile;
    if (this.router.url.includes("sales")) {
      this.infoForm = this.fb.group({
        firstName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        email: ["Boxsales@evento.sa", [Validators.required, Validators.email]],
        mobile: ["", Validators.required],
      });
    } else if (this.user) {
      firstName = this.user.firstName;
      lastName = this.user.lastName;
      email = this.user.email;
      mobile = this.user.mobile;
      this.infoForm = this.fb.group({
        firstName: [
          firstName,
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        lastName: [
          lastName,
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        email: [email, Validators.required],
        mobile: [mobile, Validators.required],
      });
    } else {
      this.infoForm = this.fb.group({
        firstName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(30),
            this.helpers.noSpecialCharsAndTrim,
          ],
        ],
        email: ["", [Validators.required, Validators.email]],
        mobile: ["", Validators.required],
      });
    }
  }

  back() {
    this.backToTickets.emit();
  }
}
